import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getLocationsForOrgId } from '@frontend/api-location';
import { ContextlessQueryObserverOptions } from '@frontend/react-query-helpers';

export const getCurrentLocationChildrenQueryKey = (locationId: string) => ['current-location-children', locationId];

export const useCurrentLocationChildrenQuery = (locationId?: string, opts?: ContextlessQueryObserverOptions) => {
  const { data, isLoading, ...query } = useQuery({
    ...opts,
    queryKey: getCurrentLocationChildrenQueryKey(locationId || ''),
    queryFn: () => {
      return getLocationsForOrgId(locationId || '');
    },
    enabled: !!locationId,
  });

  const childrenLocations = useMemo(() => {
    return data?.locations?.filter((l) => l.locationId !== locationId) || [];
  }, [data]);

  return { ...query, childrenLocations, isLoadingChildren: isLoading };
};
